// extracted by mini-css-extract-plugin
export var word = "LettersAnimation-module--word--un-tk";
export var char = "LettersAnimation-module--char--hcj1o";
export var charActive = "LettersAnimation-module--charActive--DkiWt";